


















helpers = require('../../../helpers.coffee')
on_clickaway = require('vue-clickaway')
view_model = {
  mixins: [ on_clickaway.mixin ]
  components:
    compose: require('./list_item')
    quotaExceeded: require('./quota_exceeded')

  data: ->
    current_user: Session.current_user
    list: []
    show_menu: false
    event: {}

  methods:
    onClickaway: ->
      @show_menu = false

    compose_header: (task, index) ->
      if task.contact.id
        task.contact?.full_name + ' - ' + task.contact?.business?.name
      else
        "Email "+(index+1)

    loadTaskInfo: (data) ->
      if data.event
        @event = data.event
      if !data.task
        task = new Task
        task.service = 'ManualTasksServices::Email'
        task.created_by_type = 'User'
        @incrementList(task)
      else
        @tasks_resources.get @loadTaskInfoSuccess, @unknownError, id: data.task.id unless @list.find(data.task.id)

    loadTaskInfoSuccess: (data) ->
      @incrementList(data.task)

    hideCompose: (task) ->
      @list.push task if @list.remove(task)

    incrementList: (task) ->
      @show_menu = false
      @list.remove(task) if @list.find(task)
      @list.unshift task

    removeFromList: (task) ->
      @list.remove(task)

  computed:
    limited_list: ->
      @list.slice(0,2)

    hidden_list: ->
      @list.slice(2)

    hidden_list_has_elements: ->
      @hidden_list.length > 0

  created: ->
    @tasks_resources = new TasksResource
    EventsBus.$on 'Compose::Open', @loadTaskInfo

  beforeDestroy: ->
    EventsBus.$off 'Compose::Open', @loadTaskInfo

}

exports.default = helpers.vue_include(view_model, helpers.form, helpers.filters)




// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/shared/compose/list.vue